
import GlobalComs from './components/GlobalComs.vue'
import { defineComponent } from 'vue'
import * as store from './store'
import { NConfigProvider, GlobalThemeOverrides, NDialogProvider } from 'naive-ui'
export default defineComponent({
  components: {
    NConfigProvider,
    NDialogProvider,
    GlobalComs,
  },
  setup() {

    // store
    store.provideStore()

    // themes
    const themeConf: GlobalThemeOverrides = {
      common: {
        primaryColor: '#FE2BFF',
        primaryColorHover: "#FE2BFF",
        primaryColorPressed: "#FE2BFF",
        heightLarge: "48px",
      },
    }
    return {
      themeConf
    }
  }
})
